var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M19.7803 15.5303C19.4874 15.8232 19.0126 15.8232 18.7197 15.5303L12 8.81066L5.28033 15.5303C4.98744 15.8232 4.51256 15.8232 4.21967 15.5303C3.92678 15.2374 3.92678 14.7626 4.21967 14.4697L11.4697 7.21967C11.7626 6.92678 12.2374 6.92678 12.5303 7.21967L19.7803 14.4697C20.0732 14.7626 20.0732 15.2374 19.7803 15.5303Z",
    fill: "#373F41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.b955069bf0f5a5b0efea96de41ab96a1.svg";
export { ForwardRef as ReactComponent };